import { TranslationsContext } from 'common/hooks/translations-context-provider';
import { Creative } from '../../../lib/components/creative';
import { StoreContext } from '../../../lib/store';
import style from './styles.scss';
import * as React from 'react';
import { CSSProperties, useContext } from 'react';
import classNames from 'classnames';
import { TranslationsKeys } from '../../../lib/translations';
import { BrandRecommendation } from 'common/components/brand-recommendation';

export function Component() {
  const store = useContext(StoreContext);

  const {
    discoverFontColor,
    previewIsBackgroundColored,
    backgroundColor,
    creative
  } = store.formatConfig;

  const creativeStore = store.creativeStore;

  const translate = React.useContext(TranslationsContext) as (
    path: TranslationsKeys,
    args?: TranslatorMacroReplace
  ) => string;

  const titleLabel: string = translate('discoverBrand', {
    brand: creative.name
  });

  const formatStyle: CSSProperties = {
    backgroundColor: previewIsBackgroundColored ? backgroundColor : ''
  };

  const rootStyle = creative.showDiscover
    ? classNames(style.rootStyle, style.discoverLayout)
    : classNames(style.rootStyle, style.standardLayout);

  if (creative.objectFitStrategy?.useStrategy) {
    creative.objectFit = creativeStore.isVertical
      ? creative.objectFitStrategy.portrait
      : creative.objectFitStrategy.landscape;
  }

  const imgStyle =
    creative.objectFit === 'contain' ? style.creativeContain : style.creative;

  return (
    <div className={rootStyle} style={formatStyle}>
      <div>
        {creative.showDiscover && (
          <BrandRecommendation
            titleLabel={titleLabel}
            fontColor={discoverFontColor}
            backgroundColor={formatStyle.backgroundColor}
            onClick={e => {
              store.userClickHandler.handle(e);
            }}
          />
        )}
      </div>
      <div>
        <Creative
          onClick={e => {
            store.userClickHandler.handle(e);
          }}
          imageClassName={imgStyle}
          containerClassName={style.creativeContainer}
          creativeUrl={creative.url}
          blurCreativeUrl={creative.blurCreativeUrl}
          containerStyle={{
            backgroundColor: formatStyle.backgroundColor
          }}
        ></Creative>
      </div>
    </div>
  );
}
